import * as RadixTooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";

import styles from "./arrow.module.css";

type Props = RadixTooltip.TooltipArrowProps;

const Arrow = (props: Props) => {
    const { className, ...rest } = props;

    return <RadixTooltip.Arrow className={clsx(styles.arrow, className)} {...rest} />;
};

Arrow.displayName = "Tooltip.Content.Arrow";

export { Arrow };
export type { Props as ArrowProps };
